<div
  id="faultIgnorePage"
  *appHasPermission="{
    permissions: [permissions.allPermissions.IGNORED_FAULT_LIST_READ],
  }"
>
  <div class="widget">
    @if (timeOut()) {
      <app-timeout></app-timeout>
    } @else if (loading()) {
      <div class="flex h-full justify-content-center align-items-center">
        <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
      </div>
    } @else {
      <p-table
        [scrollable]="true"
        ,
        [columns]="faultCodeColumns"
        class="p-3 tableHaderAlignTop"
        [value]="ignoredFaults()"
      >
        <ng-template #caption>
          <span>{{ "ignored_fault_list.list_title" | translate }}</span>
        </ng-template>
        <ng-template #header let-columns>
          <tr>
            @for (col of columns; track col) {
              <th>{{ col.header | translate }}</th>
            }
            <th></th>
          </tr>
        </ng-template>
        <ng-template #body let-rowData let-columns="columns">
          <tr>
            @for (col of columns; track col) {
              <td>{{ rowData[col.field] }}</td>
            }
            <td class="flex gap-3 justify-content-end">
              <app-svg-icon
                (click)="onIgnoredFaultEdit(rowData)"
                iconName="edit"
                iconColor="primary"
                class="pointer"
                iconSize="sm"
                *appHasPermission="{
                  permissions: [permissions.allPermissions.IGNORED_FAULT_LIST_UPDATE],
                }"
              ></app-svg-icon>
              <app-svg-icon
                (click)="onIgnoredFaultDelete(rowData, $event)"
                iconName="trash"
                iconColor="primary"
                class="pointer"
                iconSize="sm"
                *appHasPermission="{
                  permissions: [permissions.allPermissions.IGNORED_FAULT_LIST_DELETE],
                }"
              ></app-svg-icon>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <div class="px-3">
        <app-button
          (click)="onIgnoredFaultAdd()"
          style="position: sticky"
          buttonText="ignored_fault_list.add_ignored_fault"
        ></app-button>
      </div>
    }
  </div>
</div>
